import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  modalWrapper: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 100,
    display: 'none'
  },
  showModal: {
    display: 'block'
  },
  content: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: 'translate(50%, -50%)',
    width: 'max-content',
    maxWidth: 850,
    minWidth: 600,
    maxHeight: '100vh',
    overflow: 'auto',
    color: '#fff',
    background: 'rgba(56, 56, 56, 0.5)',
    backdropFilter: 'blur(50px)',
    borderRadius: 30,
    padding: '30px',
    textAlign: 'center',
    zIndex: 5,
    '@media (max-width: 991px)': {
      minWidth: 'initial',
      maxWidth: 640,
      borderRadius: 15,
      padding: '20px 25px'
    },
    '@media (max-width: 576px)': {
      maxWidth: '100%',
      width: '100%',
      borderRadius: 15,
      padding: '15px'
    }
  },
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    cursor: 'pointer',
    width: 20,
    height: 20,
    zIndex: 100,
    '& span, &:before': {
      position: 'absolute',
      left: 0,
      top: 9,
      height: 2,
      width: '100%',
      display: 'inline-block',
      background: 'white'
    },
    '&:before': {
      content: '""',
      transform: 'rotate(45deg)'
    },
    '& span': {
      transform: 'rotate(-45deg)'
    }
  }
});
